/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { prependSetTo, snakeToCamelCase, keysOf } from "config/Utilities";
import { CamelCase, PrependSetTo } from "config/UtilityTypes";
import { DEFAULT_STORE } from "store/types";
import { Action, Actions } from "./types";

type ActionCreators<Store> = {
  [Key in keyof Store as CamelCase<PrependSetTo<Key>>]: (
    newValue: Store[Key]
  ) => Action<typeof DEFAULT_STORE>;
};

function makeActions(): ActionCreators<typeof DEFAULT_STORE> {
  const store = DEFAULT_STORE;
  const result: Partial<Actions<typeof DEFAULT_STORE>> = {};
  for (const key of keysOf(store)) {
    result[snakeToCamelCase(prependSetTo(key))] = (
      x: typeof store[typeof key]
    ) => ({
      type: prependSetTo(key),
      payload: x,
    });
  }
  //@ts-ignore
  return result;
}

export const ActionCreators = makeActions();
